import { HTMLAttributes, ReactNode, SVGProps } from 'react';

import { twMerge } from 'tailwind-merge';
import { cardStyles, Typography } from '../../../ui';

type Props = {
  icon: (props: SVGProps<SVGSVGElement>) => ReactNode;
  title: string;
  description: string;
} & HTMLAttributes<HTMLDivElement>;

export function InfoCard(props: Props) {
  const { icon: Icon, title, description, className, ...rest } = props;

  return (
    <div
      className={twMerge(
        cardStyles({ variant: 'outlined' }),
        'p-20',
        className,
      )}
      {...rest}
    >
      <div className="flex flex-row gap-x-8">
        <Icon className="min-w-24 w-24 h-24 fill-primaryMain" />

        <div className="flex flex-col gap-y-4">
          <Typography
            variant="body-s"
            weight="medium"
            className="text-grayscale500"
          >
            {title}
          </Typography>
          <Typography
            variant="body-xs"
            weight="regular"
            className="text-grayscale400"
          >
            {description}
          </Typography>
        </div>
      </div>
    </div>
  );
}
